import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import config from '../../../config';
import trainTime from '../../../lib/TrainTime';
import Search from '../../../records/Search';
import Smartcard from '../../../records/customer/Smartcard';
import t from '../../../lib/I18n';
import { TicketTypes } from '../../../constants/AppConstants';
import TrackingActions from "../../../actions/TrackingActions";

import Icon from '../../general/Icon';
import OpenReturnCheckbox from '../OpenReturnCheckbox';
import OutboundDateSelector from './OutboundDateSelector';
import ReturnDateSelector from './ReturnDateSelector';
import DepartNowCheckbox from '../DepartNowCheckbox';

/**
 * Datetime summary for larger screens, doesnt use modals, all entry is in place
 */

class DateTimeSummarySideBySide extends React.PureComponent {

    static propTypes = {
        search: PropTypes.instanceOf(Search),
        smartcard: PropTypes.instanceOf(Smartcard),
        onChange: PropTypes.func,
        disableTodayTomorrow: PropTypes.bool
    };

    static defaultProps = {
        search: new Search(),
        onChange: _.noop,
        disableTodayTomorrow: false
    };

    _hideDepartNow = () => {
        const { search, disableTodayTomorrow } = this.props;
        return search.smartcard && disableTodayTomorrow;
    };

    handleTimebandChangeFor = (field) => (value) => {
        const search = this.props.search.set(field, value);
        this.props.onChange(search);
    };

    handleAddReturn = () => {
        TrackingActions.widgetSearchClick({ name: 'add-return' });
        const returnTitle = document.getElementById('departNow');
        if (returnTitle) { returnTitle.focus(); }
        this.props.onChange(this.props.search.setTicketType(TicketTypes.RETURN));
    };

    handleRemoveReturn = () => {
        TrackingActions.widgetSearchClick({ name: 'remove-return' });
        this.props.onChange(this.props.search.setTicketType(TicketTypes.SINGLE));
    };

    renderAddReturn () {
        return (
            <button className="btn-box btn-add-return"
                    onClick={ this.handleAddReturn }>
                <Icon icon="add" /><br/>{ t('booking.dates.addReturn') }
            </button>
        );
    }

    renderReturn (max) {
        const { search, onChange } = this.props;
        return (
            <div>
                <ReturnDateSelector id="return-timeband-selector"
                                    timeband={ search.returnDateTime }
                                    disabled={ search.isOpenReturn() }
                                    onChange={ this.handleTimebandChangeFor('returnDateTime') }
                                    min={ search.outboundDateTime.datetime }
                                    max={ max } />
                <OpenReturnCheckbox search={ search } onChange={ onChange } ticketTypeWhenOff={ TicketTypes.RETURN }/>
            </div>
        );
    }

    render () {
        const { search, smartcard, onChange } = this.props;

        const min = (search.smartcard && smartcard && smartcard.isAwaitingProduct()) ?
            trainTime().addWorkingDays(config.get('minAwaitingSmartcardProductDays')) : trainTime();
        const max = trainTime().endOf('day').add(config.get('maxOutboundDays'), 'days');

        //For smartcard tickets, they are only day return so set the return date max to the outbound date
        const outboundDateTime = search.outboundDateTime.datetime.clone();
        const returnMax = search.smartcard ? outboundDateTime.endOf('day') : max;

        return (
            <Row className="datetime__summary-side-by-side">
                <Col xs={ 6 }>
                    <span className="label" >
                        { t('booking.dates.outbound') }
                    </span>
                    <OutboundDateSelector id="outbound-timeband-selector"
                                          timeband={ search.outboundDateTime }
                                          onChange={ this.handleTimebandChangeFor('outboundDateTime') }
                                          disabled={ search.departNow }
                                          disableTodayTomorrow={ this._hideDepartNow() }
                                          min={ min }
                                          max={ max }/>
                    { !this._hideDepartNow() && <DepartNowCheckbox search={ search } onChange={ onChange }/> }
                </Col>

                <Col xs={ 6 } className="timeband-selector--return">
                    <span className="label" id="returnSelectorTitle">
                        { t('booking.dates.return') }
                    </span>
                    { !search.isSingle() &&
                    <button className="btn otrl-inline btn-link like-link no-return pull-right text-sm"
                            onClick={ this.handleRemoveReturn }>
                        { t('booking.ticketType.remove-return') }
                    </button> }

                    { search.isSingle() ? this.renderAddReturn() : this.renderReturn(returnMax) }
                </Col>
            </Row>
        );
    }

}

export default DateTimeSummarySideBySide;



// WEBPACK FOOTER //
// ./src/components/search/dates/DateTimeSummarySideBySide.js